import styled from 'styled-components';

export const StatusTag = styled.span`
    display: inline-flex;
    border-radius: 2px;
    padding: 2px 4px;
    font-size: 12px;
    font-weight: 700;
    ${p =>
      p.status &&
      p.status === 'Submitted' &&
      `
        background-color: #FFF9EE;
        color: #D68A09;
    `}
    ${p =>
      p.status &&
      p.status === 'Rejected' &&
      `
        background-color: #FFF5F6;
        color: #EB2026;
    `}
    ${p =>
      p.status &&
      p.status === 'Accepted' &&
      `
        background-color: #EEFFFB;
        color: #1A7971;
    `}
`;
